export default function parseStringPrice(price: string): number {
    return Number(String(price).replace(/(\s|&nbsp;)/g, ""));
}
